import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationResult } from '@shared/_constants';

@Component({
  selector: 'app-financialtype-info',
  templateUrl: './financialtype-info-dialog.component.html',
})
export class FinancialTypeInfoDialogComponent {
  constructor(private activeModal: NgbActiveModal) {}

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }
}
